<span class="p-inputnumber p-component p-inputnumber-buttons-stacked">
  <input
    pInputText
    [id]="inputId()"
    type="text"
    class="text-end"
    [class.hidden-buttons]="hideButtons()"
    [style.width]="width()"
    [(ngModel)]="_value"
    labValidateNumber
    [minimum]="minimum()"
    [maximum]="maximum()"
    [disabled]="disabled()"
    (input)="changeValue('input')"
    (blur)="changeValue('blur')"
    (keydown.enter)="changeValue('enter')"
  />
  @if (!hideButtons()) {
    <span class="p-inputnumber-button-group">
      <button
        pButton
        pRipple
        type="button"
        class="p-button-outlined p-inputnumber-button p-inputnumber-button-up"
        [class.p-button-text]="textButtons()"
        icon="fa-solid fa-angle-up"
        [disabled]="disabled() || isMaximum()"
        (click)="increase()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        class="p-button-outlined p-inputnumber-button p-inputnumber-button-down"
        [class.p-button-text]="textButtons()"
        icon="fa-solid fa-angle-down"
        [disabled]="disabled() || isMinimum()"
        (click)="decrease()"
      ></button>
    </span>
  }
</span>
